import { ApolloClient, createHttpLink, InMemoryCache, gql } from '@apollo/client';
import {setContext} from '@apollo/client/link/context'

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_URL_GRAPH,
});

const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'X-API-KEY': process.env.REACT_APP_APIKEY_GRAPH,
      },
    }
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
});

export const saveCreateEventAsesor  = async (idEmployee, businessKey, idResponsable, description, startDate, endDate, address, id) => {

        const MutationSaveCreateEvent = gql`
            mutation saveCreateEvent {
                createEvent( user: "${process.env.REACT_APP_CREATE_USER}", password: "${process.env.REACT_APP_CREATE_PASSWORD}"
                    input: {
                    idEmployee: "${idEmployee}", 
                    businessKey: "${businessKey}", 
                    idResponsable: "${idResponsable}", 
                    title: "Contactar Lead", 
                    description:"${description}"
                    type: 10,
                    creditType: 1,
                    startDate: "${startDate}",
                    endDate: "${endDate}",
                    latitude: 0,
                    longitude: 0,
                    address: "${address}",
                    id: "${id}"
                }) {
                code
                message
                }
            }`;

        try {
            const response = await client.mutate({
                mutation: MutationSaveCreateEvent,
            });
        
            return responseSaves(response.data.saveCreateEvent)
                
        } catch (error) {
            return responseSaves('error')
        }
    }
     
    const responseSaves = (resp) => {
        return resp
    }